import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import React, { Suspense } from "react";
import Panel from "../../views/Panel/Panel";
import Menu from "../../components/organisms/Menu/Menu";
import NotFound from "../../views/NotFound/NotFound";
import Contact from "../../views/Contact/Contact";
import Itinerary from "../../views/Itinerary/Itinerary";
import { decrypt } from "../../utilities/Encriptacion";
import CompanyRouter from "../../utilities/Redirect";
import Comment from "../../views/Comments/Comment";

const AuthRoutes: React.FC = () => {
    const location = useLocation();
    const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION!;
    const encryptedData = sessionStorage.getItem('dataClient');

    // Verify if 'dataClient' is in sessionStorage
    if (!encryptedData) {
        throw new Error("No data to decrypt");
    }

    let company: string;
    try {
        const data = decrypt(encryptedData, CLAVE);
        company = JSON.parse(data).initials;
    } catch (error) {
        console.error("Error decrypting data:", error);
        return <Navigate to="/" replace/>;
    }

    const validRoutes = [`/${company}/panel`, `/${company}/contacto`, `/${company}/paradas`,  `/${company}/comentarios`];
    const showMenu = validRoutes.includes(location.pathname);

    return (
        <Suspense fallback={<>Loading...</>}>
            <CompanyRouter />
            {showMenu && <Menu />}
            <Routes>
                <Route path={`/${company}/panel`} element={<Panel />} />
                <Route path={`/${company}/paradas`} element={<Itinerary />} />
                <Route path={`/${company}/contacto`} element={<Contact />} />
                <Route path={`/${company}/comentarios`} element={<Comment />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Suspense>
    );
};

export default AuthRoutes;
